import { Routes } from '@angular/router';
import { NavigateExternalComponent } from '@x/common/navigate/navigate-external/navigate-external.component';
import { authGuard } from '@x/ecommerce-shop/app/core/auth/guards/auth.guard';
import { isLoggedOutGuard } from '@x/ecommerce-shop/app/core/auth/guards/is-logged-out.guard';

export const routes: Routes = [
  {
    path: 'externals',
    component: NavigateExternalComponent,
  },
  {
    path: 'login',
    canActivate: [isLoggedOutGuard],
    loadChildren: () => import('./auth-flow/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./auth-flow/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'checkout',
    canActivate: [authGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'subscriber',
    canActivate: [authGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./subscriber-checkout/subscriber.module').then((m) => m.SubscriberModule),
  },
  { path: 'external', component: NavigateExternalComponent },
  {
    path: '',
    loadChildren: () => import('./channel/channel.module').then((m) => m.ChannelModule),
  },
  {
    path: '**',
    loadChildren: () => import('./channel/channel.module').then((m) => m.ChannelModule),
  },
];
